export default "__VITE_ASSET__CaBOvlXE__"